import { Select, Modal, Cascader } from 'antd';
import React, { useMemo, useState } from 'react';
import { Property } from 'patternx-svg';
import styles from './index.module.less';
import AdsorptionModal from '../adsorption';

interface Props {
  appOptions: any[];
  categoryOptions: any[];
  adsorptionCategorys: any[];
  referencePointHorizontals: any[];
  referencePointVerticals: any[];
  referenceFaceVerticals: any[];
  referenceFaceHorizontals: any[];
  targetHosts: any[];
  onClose: () => void;
  onChange: (params: any) => void;
  selects: ELEMENT.Component[];
}
const BatchEditModal: React.FC<Props> = (props: Props) => {
  const {
    appOptions,
    onClose,
    onChange,
    categoryOptions,
    adsorptionCategorys,
    referencePointHorizontals,
    referencePointVerticals,
    referenceFaceVerticals,
    referenceFaceHorizontals,
    targetHosts,
    selects,
  } = props;
  const [appList, setAppList] = useState([]);
  const [categoryId, setCategoryId] = useState('');
  const [categorys, setCategorys] = useState<string[]>([]);
  //行为规则参数
  const [isShowAdsorptionModal, setIsShowAdsorptionModal] = useState(false);
  const [extData, setExtData] = useState<any>({
    extData: {},
    adsorptionCategory: undefined,
  });

  const onAppChange = (values: any) => {
    setAppList(values);
  };
  const onSubmit = () => {
    onChange({
      appList,
      categoryId,
      adsorptionCategory: extData.adsorptionCategory,
      extData: extData.extData,
      categorys,
    });
  };

  const onCategoryChange = (values: any[]) => {
    if (!values || values.length === 0) {
      setCategoryId('');
      setCategorys([]);
      return;
    }
    setCategoryId(values[values.length - 1]);
    setCategorys(values);
  };

  const isAbleSet = useMemo(() => {
    const isAllDisabled = selects?.every((s) => !s.isAllowSetting);
    return isAllDisabled ? false : true;
  }, [selects]);

  const onLocalAdsorptionCategoryChange = (value: string, option: any) => {
    if (value === 'custom') {
      setIsShowAdsorptionModal(true);
      setExtData({
        adsorptionCategory: 'custom',
        extData: {
          referenceFaceVertical: '',
          referenceFaceHorizontal: '',
          targetHost: '',
          referencePointVertical: '',
          referencePointHorizontal: '',
        },
      });
    } else {
      const extend = JSON.parse(option?.extend || '{}');
      setExtData({
        adsorptionCategory: value,
        extData: {
          referenceFaceVertical: extend?.referenceFaceVertical || '',
          referenceFaceHorizontal: extend?.referenceFaceHorizontal || '',
          targetHost: extend?.targetHost || '',
          referencePointVertical: extend?.referencePointVertical || '',
          referencePointHorizontal: extend?.referencePointHorizontal || '',
        },
      });
    }
  };

  const okButtonIsOk = useMemo(() => {
    if (appList?.length > 0 || categoryId || extData.adsorptionCategory) {
      return true;
    }
    return false;
  }, [appList, categoryId, extData]);

  const onChangeAdsorption = (params: any) => {
    setExtData((d: any) => ({
      adsorptionCategory: params.adsorptionCategory,
      extData: {
        referenceFaceVertical: params?.extData?.referenceFaceVertical || '',
        referenceFaceHorizontal: params?.extData?.referenceFaceHorizontal || '',
        referencePointVertical: params?.extData?.referencePointVertical || '',
        referencePointHorizontal: params?.extData?.referencePointHorizontal || '',
        targetHost: params?.extData?.targetHost || '',
      },
    }));
    setIsShowAdsorptionModal(false);
  };

  const onCloseAdsorption = (isEmpty: boolean) => {
    setIsShowAdsorptionModal(false);
    if (isEmpty) {
      setExtData((d: any) => ({
        adsorptionCategory: undefined,
        extData: {},
      }));
    }
  };

  return (
    <>
      <Modal
        visible={true}
        width={400}
        title="批量编辑"
        onOk={onSubmit}
        onCancel={onClose}
        okButtonProps={{ disabled: !okButtonIsOk }}
        style={{ top: 200 }}
      >
        <div style={{ width: '80px' }}>分类</div>
        <div className="flex-ai-center  mt12">
          <Cascader
            placeholder="请选择分类"
            expandTrigger="hover"
            style={{ width: '100%', maxWidth: '350px' }}
            defaultValue={[]}
            options={categoryOptions}
            onChange={onCategoryChange}
            fieldNames={{
              label: 'name',
              value: 'id',
              children: 'children',
            }}
          ></Cascader>
        </div>
        <div style={{ width: '80px' }} className="mt16">
          行为规则
        </div>
        <div className="flex-ai-center mt12">
          <Select
            placeholder="请选择行为规则"
            value={extData.adsorptionCategory}
            onChange={(val: any, option: any) => onLocalAdsorptionCategoryChange(val, option)}
            style={{ width: '0', flex: 1 }}
            options={adsorptionCategorys}
            showArrow
            // allowClear
            disabled={!isAbleSet}
            popupClassName={styles.adsorptionSelect}
          />
          <span
            className={`${styles.icon} ${isAbleSet ? '' : styles.disableIcon}`}
            onClick={() => {
              if (isAbleSet) {
                setIsShowAdsorptionModal(true);
              }
            }}
          >
            <Property />
          </span>
        </div>
        <div style={{ width: '80px' }} className="mt16">
          应用
        </div>
        <div className="flex-ai-center mt12">
          <Select
            mode="multiple"
            placeholder="请选择应用"
            value={appList}
            onChange={onAppChange}
            style={{ width: '100%' }}
            options={appOptions}
            showArrow
            fieldNames={{
              label: 'name',
              value: 'code',
            }}
          />
        </div>
      </Modal>
      {isShowAdsorptionModal && (
        <AdsorptionModal
          onChange={onChangeAdsorption}
          onClose={onCloseAdsorption}
          adsorptionCategorys={adsorptionCategorys}
          referencePointHorizontals={referencePointHorizontals}
          referencePointVerticals={referencePointVerticals}
          referenceFaceVerticals={referenceFaceVerticals}
          referenceFaceHorizontals={referenceFaceHorizontals}
          targetHosts={targetHosts}
          data={extData}
        />
      )}
    </>
  );
};

export default React.memo(BatchEditModal);
